"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVToJSON = exports.CSVFromJSONTyped = exports.CSVFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function CSVFromJSON(json) {
    return CSVFromJSONTyped(json, false);
}
exports.CSVFromJSON = CSVFromJSON;
function CSVFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !runtime_1.exists(json, '_id') ? undefined : _1.CSVIDFromJSON(json['_id']),
        'data': json['data'],
    };
}
exports.CSVFromJSONTyped = CSVFromJSONTyped;
function CSVToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': _1.CSVIDToJSON(value._id),
        'data': value.data,
    };
}
exports.CSVToJSON = CSVToJSON;
